define('boxes/controllers/login-controller',['jquery', 'boxes/controllers/box-controller', 'boxes/login-box', 'boxes/forgotten-password-box', 'boxes/email-verification-box', 'boxes/postal-mobile-verification-box', 'boxes/changePasswordBox', 'boxes/events/loginEvent', 'boxes/events/controller-event', 'boxes/helpers/doLogin', 'all/sliding-panel', 'all/pretty-links', 'all/slidingContentNavigation'], function ($, boxController, loginBox, forgottenPasswordBox, emailVerificationBox, postalMobileVerificationBox, changePasswordBox, loginEvent, controllerEvent, doLogin, slidingPanel, prettyLinks, slidingContentNavigation) {
    'use strict';
    var controller = boxController.create('.sliding-login.controller');

    function start(boxControllerSelector, doneCallback, startWithForgottenPassword, tempPassLoginData) {
        var startIndex = -1;
        if(startWithForgottenPassword === true){
            startIndex = 1;
        }
		if(tempPassLoginData) {
			startIndex = 0;
		}
        controller.setSelector(boxControllerSelector);
        controller.start(function(){ setup(startWithForgottenPassword, tempPassLoginData);}, startIndex);
        controller.trigger(loginEvent.SET_LOGIN_DONE_CALLBACK, doneCallback);
        controller.trigger(loginEvent.SET_BACK_TO_LOGIN_CALLBACK, function(){
            controller.goToBox(controller.boxes[0]);
        });
        return controller;
    }

    function setup(startWithForgottenPassword, tempPassLoginData) {

        controller.on(controllerEvent.RESET, function() {
            reset();
        });

        var $boxes = controller.find('.boxes');

        controller.setBoxes([
            loginBox.create($boxes.find('.give-login.box'), controller),
            changePasswordBox.create($boxes.find('.change-password.box'), controller, tempPassLoginData),
            forgottenPasswordBox.create($boxes.find('.forgotten-password.box'), controller, startWithForgottenPassword),
            emailVerificationBox.create($boxes.find('.box.email-verification'), controller, 'forgottenPassword'),
            //postalMobileVerificationBox.create($boxes.find('.postal-email-verification.box'), controller)
        ]);
    }

    function reset(){
        var ERROR_CLASS = 'has-error';
        var VALID_CLASS = 'is-valid';

        controller.find('input').each(function(){
            $(this).val('');
            $(this).parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
        });
        controller.find('.box').hide();
    }

	var startChangePasswordClass = {
		createInstance: function(parameters){
			var changePassword = {
				start: function(){
					var boxControllerSelector = '.sliding-login.controller';
					var uName = $('#loginusername').val();
					var tempPass = $('#loginpassword').val();
					var $controller = start(boxControllerSelector, function(response){

						$('#sliding-content-wrapper').find('.close').click();

						if(response !== undefined && response.PARAM_PLAYER_INFO !== undefined){
							doLogin.doLogin(response, undefined, undefined);
						} else{
							// Reload page, some problem doing it in the middle of an unload event, therefore in a timeout
							setTimeout(function(){window.top.location.reload();}, 500);
						}

					}, true, { "uName": uName, "tempPass": tempPass });
					return $controller;
				},
				args: function(){
					return undefined;
				}
			};
			return changePassword;
		},
		createHashTag: function() {
			return this.baseHashTag;
		},
		baseHashTag: 'changePassword',
		dontShowIfAuthenticated: true
	}

    var startForgottenPasswordClass = {
        createInstance: function(parameters){
            var forgottenPassword = {
                start: function(){
                    var boxControllerSelector = '.sliding-login.controller';
                    var $controller = start(boxControllerSelector, function(response){

                        $('#sliding-content-wrapper').find('.close').click();

                        if(response !== undefined && response.PARAM_PLAYER_INFO !== undefined){
                            doLogin.doLogin(response, undefined, undefined);
                        } else{
                            // Reload page, some problem doing it in the middle of an unload event, therefore in a timeout
                            setTimeout(function(){window.top.location.reload();}, 500);
                        }

                    }, true);
                    return $controller;
                },
                args: function(){
                    return undefined;
                }
            };
            return forgottenPassword;
        },
        createHashTag: function() {
            return this.baseHashTag;
        },
		baseHashTag: 'forgottenPassword',
        dontShowIfAuthenticated: true
    };

    var startLoginClass = {
        createInstance: function (parameters, afterSuccessfulLoginCallback) {
            var loginPopup = {
                start: function (closePanelFunction) {
                    var boxControllerSelector = '.sliding-login.controller';
                    var $controller = start(boxControllerSelector, function (response) {

                        if (closePanelFunction === undefined) {
                            closePanelFunction = function () {
                                $('#sliding-content-wrapper').find('.close').click();
                            };
                        }
                        closePanelFunction();


                        if (response !== undefined && response.PARAM_PLAYER_INFO !== undefined) {
                            doLogin.doLogin(response, afterSuccessfulLoginCallback);
                        } else {
                            // Reload page, some problem doing it in the middle of an unload event, therefore in a timeout
                            setTimeout(function () {
                                window.top.location.reload();
                            }, 500);
                        }

                    }, false);

                    return $controller;
                },
                args: function () {
                    return undefined;
                }
            };

            return loginPopup;
        },
        createHashTag: function () {
            return this.baseHashTag;
        },
        baseHashTag: 'login',
        dontShowIfAuthenticated: true
    };

    var startReLoginClass = {
        createInstance: function(parameters){
            var reloginPopup = {
                start: function(){

                    var boxControllerSelector = '.sliding-login.controller';
                    var $controller = start(boxControllerSelector, function(response){

                        var afterSuccessfulLoginCallback = function(){
                            // After successful relogin, then load the original location again, Possibly we have the relogin hash in location here?

                            location.reload(true);
                        };

                        slidingPanel.closePanel(undefined, $controller, function(){
                            // After panel is closed, we login, and then we reload location
                            if(response !== undefined && response.PARAM_PLAYER_INFO !== undefined){
                                doLogin.doLogin(response, afterSuccessfulLoginCallback);
                            } else{
                                // Reload page, some problem doing it in the middle of an unload event, therefore in a timeout
                                setTimeout(function(){window.top.location.reload();}, 500);
                            }
                        });


                    }, false);

                    return $controller;
                },
                args: function() {
                    return {
                        closeButtonScript: function ($controller) {
                            // OnCancel, go to Promotions
                            slidingPanel.closePanel(undefined, $controller, function () {
                                window.location.replace(prettyLinks.getLink('Promotions'));
                            });
                        }
                    };
                }
            };

            return reloginPopup;
        },
        createHashTag: function() {
            return this.baseHashTag;
        },
        baseHashTag: 'relogin',
        dontShowIfAuthenticated: true
    };



    return {
        start: start,
		startChangePasswordClass: startChangePasswordClass,
        startForgottenPasswordClass: startForgottenPasswordClass,
        startLoginClass: startLoginClass,
        startReLoginClass: startReLoginClass
    };
});

